import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useConfig } from '../context/ConfigContext';
import api from '../api/axios';
import Header from '../components/Header';

const Login = () => {
    const { login } = useAuth();
    const { config, loading: configLoading } = useConfig();
    const [loginInput, setLoginInput] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        const result = await login(loginInput);
        if (result.success) {
            try {
                await api.post('/sessions/log', {
                    page_name: 'login',
                    action_type: 'login'
                });
            } catch (err) {
                console.error("Failed to log login action", err);
            }
            navigate('/');
        } else {
            setError(result.message);
            setIsLoading(false);
        }
    };

    if (configLoading) {
        return (
            <div className="min-h-screen bg-[#1c0042] flex items-center justify-center">
                <div className="w-10 h-10 border-4 border-white/20 border-t-white rounded-full animate-spin"></div>
            </div>
        );
    }

    const primaryColor = config?.primaryColor || '#9d4edd';
    const pageDesign = config?.pageDesigns?.login || { enabled: true, bgImage: '', showBrain: true };

    return (
        <div className="min-h-screen bg-[#1c0042] flex flex-col items-center justify-center p-6 sm:p-10 animate-fadeIn bg-gradient-to-b from-[#1c0042] to-[#0e0024]">
            {/* Background Layer */}
            {pageDesign.bgImage && (
                <div
                    className="fixed inset-0 z-0 pointer-events-none"
                    style={{
                        backgroundImage: `url(${pageDesign.bgImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundAttachment: 'fixed',
                    }}
                ></div>
            )}
            <Header title={pageDesign.title} subtitle={pageDesign.subtitle} />

            {/* Form Section */}
            <div className="w-full max-w-xs z-10 space-y-8">
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="space-y-2">
                        <label className="text-[10px] uppercase font-black tracking-[0.3em] text-white/40 pl-2">
                            {config?.registration_fields?.identification === false ? 'Email' : 'Identificación'}
                        </label>
                        <input
                            className="w-full bg-white/5 border border-white/10 p-5 rounded-[30px] focus:outline-none focus:ring-4 focus:ring-purple-500/20 transition-all font-bold text-white text-center shadow-2xl backdrop-blur-md placeholder:text-white/20"
                            placeholder={config?.registration_fields?.identification === false ? 'tu@email.com' : 'Ej: 12345678'}
                            value={loginInput}
                            onChange={(e) => setLoginInput(e.target.value)}
                            required
                        />
                    </div>

                    {error && (
                        <div className="bg-red-500/20 text-red-200 p-4 rounded-2xl text-[10px] font-black uppercase tracking-widest border border-red-500/30 text-center animate-shake">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="btn-premium w-full text-lg"
                        style={{ backgroundColor: primaryColor }}
                    >
                        {isLoading ? 'Accediendo...' : 'Ingresar'}
                    </button>
                </form>

                <div className="text-center">
                    <p className="text-white/40 text-xs font-medium">¿Nuevo en el evento?</p>
                    <Link to="/register" className="text-white font-black text-xs uppercase tracking-[0.2em] mt-2 inline-block hover:text-purple-300 transition-colors">
                        Haz tu Registro Aquí
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Login;
